import React from 'react'
import { connect } from 'react-redux'
import { ThemeProvider } from '@material-ui/styles'
import { loadTheme } from 'themes'

const App = (props) => {
  const currentTheme = loadTheme()
  return (
    <ThemeProvider theme={currentTheme.theme} key={props.layout.themeKey}>
      <div className={`theme-${currentTheme.id}`} key={props.layout.layoutKey}>{props.children}</div>
    </ThemeProvider>
  )
}

export default connect(
  ({ layout }) => ({ layout })
)(App)
